module.exports = __webpack_public_path__ + "images/emoji/open_file_folder.3bef99712d74cbe27047.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/open_file_folder.png
// module id = xNNY
// module chunks = 14